<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-7 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <router-link to="/help">
            Help
          </router-link>
          <span class="mr-2 ml-2"> / </span>

          <router-link :to="`/help/${moduleSlug}`">
            {{ moduleName }}
          </router-link>
        </div>
        <div class="col-lg-5 col-md-6 col-sm-6 col-12 alinmov3">
          <BoxSearch />
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
          <div class="card">
            <div class="articles">
              <span class="date-article">{{ formatDate(document.date) }}</span>
              <h1 class="title-article ">{{ document.title }}</h1>
              <div v-html="document.content"></div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <div class="card">
            <h2 class="max-title text-left mb-3">Related</h2>

            <CardArticles
              v-if="module"
              size="md"
              :excerpt="true"
              :searchCriteria="{
                filtering:
                  module === 'RELEASE'
                    ? {
                        app: 'INTERNAL',
                        type: 'RELEASE',
                        status: 'PUBLISHED'
                      }
                    : {
                        app: 'INTERNAL',
                        module: module,
                        status: 'PUBLISHED'
                      },
                sorting: {
                  sort: 'CREATED_AT',
                  order: 'ASCENDING'
                },
                pagination: {
                  limit: 5,
                  page: 1
                }
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import WSelect from "@/components/Select";
import Swal from "sweetalert2";
import CardArticles from "../components/CardArticles.vue";
import BoxSearch from "../components/BoxSearch.vue";
import { DocumentsAPI } from "../../../../../core/api";
import { goBack } from "../../../../../helpers/commons.helpers";
import { MODULES } from "../../../../../core/constants/app";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "DocumentDetails",
  data() {
    return {
      document: {
        title: "",
        type: "",
        module: "",
        images: [],
        short_description: "",
        slug: "",
        date: moment(),
        content: ""
      },
      image: "",
      moduleSlug: "",
      documentSlug: "",
      module: "",
      moduleName: "",
      modules: MODULES
    };
  },
  watch: {
    "$route.params": {
      handler: async function(current, old) {
        let params = current;
        this.moduleSlug = params.moduleSlug;
        this.documentSlug = params.documentSlug;
        this.module = this.getModuleBySlug(this.moduleSlug);
        await this.getDocumentByDetails("INTERNAL", this.documentSlug);
      },
      deep: true
    }
  },
  async created() {
    this.moduleSlug = this.$route.params.moduleSlug;
    this.documentSlug = this.$route.params.documentSlug;
    this.module = this.getModuleBySlug(this.moduleSlug);
    await this.getDocumentByDetails("INTERNAL", this.documentSlug);

    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Help",
        to: "/help"
      },
      {
        text: this.moduleName,
        active: true
      }
    ];

    this.setItemsBread(bread);
  },
  methods: {
    goToPreviousPage() {
      goBack(this);
    },
    async getDocumentByDetails(app, documentSlug) {
      try {
        this.setLoad(true);
        let { data } = await DocumentsAPI.getDocumentDetails(
          app,
          documentSlug,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let document = data.data;
          this.document.title = document.title;
          this.document.type = document.type;
          this.document.module = document.module;
          this.document.images = document.images;
          this.image =
            this.document.images.length > 0
              ? this.document.images[0]
              : "https://upcdn.io/FW25b8h/raw/documents/covers/rhomtrip-img-doc.png";
          this.document.short_description = document.short_description;
          this.document.date = document.date;
          this.document.slug = document.slug;
          this.document.content = document.content;
          let moduleSlug =
            this.document.type === "RELEASE" ? "RELEASE" : this.document.module;
          this.moduleName = this.getModuleName(moduleSlug);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    getModuleBySlug(slug) {
      if (slug === "account") {
        return "ACCOUNT";
      } else if (slug === "driver") {
        return "DRIVER";
      } else if (slug === "areas") {
        return "AREAS";
      } else if (slug === "customers") {
        return "CUSTOMERS";
      } else if (slug === "destinations") {
        return "DESTINATIONS";
      } else if (slug === "documentation") {
        return "DOCUMENTATION";
      } else if (slug === "PARTNERS") {
        return "partners";
      } else if (slug === "experiences") {
        return "EXPERIENCES";
      } else if (slug === "global") {
        return "GLOBAL";
      } else if (slug === "logs") {
        return "LOGS";
      } else if (slug === "profile") {
        return "PROFILE";
      } else if (slug === "rates") {
        return "RATES";
      } else if (slug === "reservations") {
        return "RESERVATIONS";
      } else if (slug === "suppliers") {
        return "SUPPLIERS";
      } else if (slug === "team") {
        return "TEAM";
      } else if (slug === "vehicles") {
        return "VEHICLES";
      } else if (slug === "vehicles-gallery") {
        return "VEHICLES_GALLERY";
      } else if (slug === "release") {
        return "RELEASE";
      } else if (slug === "dashboard") {
        return "DASHBOARD";
      } else {
        return "";
      }
    },
    formatDate(date) {
      return moment
        .parseZone(date)
        .utc(true)
        .format("DD-MMM-YYYY");
    },
    getModuleName(module) {
      if (module === "RELEASE") {
        return `Releases`;
      } else {
        let item = this.modules.find(i => i.value === module);
        return item ? item.name : "";
      }
    },
    ...mapMutations(["setItemsBread", "setLoad"])
  },
  computed: {
    ...mapGetters(["sesion", "sigout"])
  },
  filters: {},
  components: {
    WSelect: WSelect,
    Swal,
    CardArticles: CardArticles,
    BoxSearch: BoxSearch
  }
};
</script>
